import { useQuery } from "@tanstack/react-query";
import { Game } from "@/types";
import { getFirebaseServices } from "@/lib/firebase/client";
import { collection, getDocs } from "firebase/firestore";

const fetchGames = async (): Promise<Game[]> => {
  const services = getFirebaseServices();
  if (!services) throw new Error("Firebase not configured");

  const snapshot = await getDocs(collection(services.db, "games"));
  return snapshot.docs.map((d) => ({ id: d.id, ...(d.data() as any) })) as Game[];
};

export function useGamesQuery() {
  return useQuery({ queryKey: ["games"], queryFn: fetchGames });
}
